export const is3DFile = (fileName) => {
  return fileName.endsWith(".glb") || fileName.endsWith(".usdz");
};

export const getFileType = (fileName) => {
  const fileTypeMatch = fileName.match(/\.(\w+)$/);
  return fileTypeMatch ? fileTypeMatch[1] : "unknown";
};
